module.exports = {
	"ha": "bc",
	"id": 5.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by PWID Status, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -165,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 96.875,
						"dataLabels": {
							"enabled": true,
							"format": "2325"
						}
					},
					{
						"y": 88.41666666666667,
						"dataLabels": {
							"enabled": true,
							"format": "2122"
						}
					},
					{
						"y": 83.125,
						"dataLabels": {
							"enabled": true,
							"format": "1995"
						}
					},
					{
						"y": 73.70833333333333,
						"dataLabels": {
							"enabled": true,
							"format": "1769"
						}
					},
					{
						"y": 56.375,
						"dataLabels": {
							"enabled": true,
							"format": "1353"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.3145016908693,
						"dataLabels": {
							"enabled": true,
							"format": "4892"
						}
					},
					{
						"y": 88.74079968171871,
						"dataLabels": {
							"enabled": true,
							"format": "4461"
						}
					},
					{
						"y": 84.80206882832704,
						"dataLabels": {
							"enabled": true,
							"format": "4263"
						}
					},
					{
						"y": 79.72946091108017,
						"dataLabels": {
							"enabled": true,
							"format": "4008"
						}
					},
					{
						"y": 69.42510443604536,
						"dataLabels": {
							"enabled": true,
							"format": "3490"
						}
					},
					{
						"y": null
					},
					{
						"y": 77.27572559366754,
						"dataLabels": {
							"enabled": true,
							"format": "2343"
						}
					},
					{
						"y": 46.965699208443276,
						"dataLabels": {
							"enabled": true,
							"format": "1424"
						}
					},
					{
						"y": 43.073878627968334,
						"dataLabels": {
							"enabled": true,
							"format": "1306"
						}
					},
					{
						"y": 39.70976253298153,
						"dataLabels": {
							"enabled": true,
							"format": "1204"
						}
					},
					{
						"y": 34.300791556728235,
						"dataLabels": {
							"enabled": true,
							"format": "1040"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -3.125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.731182795698922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.984919886899154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.32832080200501,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.516110797060485,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.685498309130696,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.810302534750614,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.438466711499666,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.981703026037999,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.924151696606788,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -22.724274406332455,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.223218096457536,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.286516853932579,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.810107197549765,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.621262458471762,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=2400"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=5027"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=3032"
			}
		],
		"dataTable": {
			"IDU": [
				2400,
				2325,
				2122,
				1995,
				1769,
				1353
			],
			"Non-IDU": [
				5027,
				4892,
				4461,
				4263,
				4008,
				3490
			],
			"Unknown": [
				3032,
				2343,
				1424,
				1306,
				1204,
				1040
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_6.json
// module id = 171
// module chunks = 0